import { ASSET_EKO_ICON, ASSET_EKO_PREFIX, ASSET_ICON_DIR, ASSET_ICON_EXTENSION } from '../constants/asset.constants';

export const isEkoAssetType = (assetTypeName: string | null | undefined): boolean =>
  (assetTypeName ?? '').substring(0, ASSET_EKO_PREFIX.length) === ASSET_EKO_PREFIX;

export const assetTypeIconUrl = (assetTypeName: string | null | undefined): string | null => {
  if (!assetTypeName) return null;
  if (isEkoAssetType(assetTypeName)) return ASSET_EKO_ICON;
  return `${ASSET_ICON_DIR}${assetTypeName.toLowerCase()}${ASSET_ICON_EXTENSION}`;
};
